<template>
  <div class="container-sm">
    <div class="ox-control-container">
      <div
        class="ox-control-wrapper"
        v-for="(value) in sortedOptions"
        :key="value.id"
      >
        <button
          class="option"
          @click="handleOptionClick(value)"
          :class="getOptionClassName(value)"
          :disabled="isSolvedQuiz"
        >
          <img
            v-if="value.content.toLowerCase() === 'o'"
            src="@/assets/images/ic-o.svg"
            alt="icon"
          />
          <img
            v-else
            src="@/assets/images/ic-x.svg"
            alt="icon"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash';
import quizOptionsControls from '@/mixins/quizOptionsControls';

export default {
  name: 'quiz-ox-control',

  mixins: [quizOptionsControls],

  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    sortedOptions() {
      return sortBy(this.options, 'content');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/styles/components/_typographies';
  @import '../assets/styles/components/_breakpoints';
  @import '../assets/styles/components/_variables';

  .ox-control-container {
    padding: 14px 0px 14px 0px;
    margin: 0 auto;
    display: table;

    .ox-control-wrapper {
      display: table-cell;

      .option {
        display: block;
        padding: 12px 16px;
        background-color: #fff;
        border: solid 1px #cccccc;
        width: 80px;
        height: 80px;
        border-radius: 40px;
        cursor: pointer;
        margin: 0 30px 0 30px;

        &:hover {
          background-color: #cccccc;
        }

        &:active {
          background-color: #cccccc;
        }

        &:focus {
          outline: none;
          background-color: #cccccc;
        }

        &:disabled {
          background-color: #cccccc;
        }

        &.selected {
          background-color: #cccccc;
        }

      }
    }
  }
</style>
